import { useState, useEffect } from 'react';
import { frontend, backend } from '../../../config';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { classNames } from '../../../helper/classNames';

type Props = {
  gameId: string | undefined;
};

const QrCode = ({ gameId }: Props) => {
  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);

  useEffect(() => {
    // don't fetch data if gameId is undefined, qrDataUrl is already set
    if (!gameId || qrDataUrl) return;

    const link = frontend.host + '/game/join?gameId=' + gameId;

    const fetchQrDataUrl = async () => {
      const response = await fetch(
        backend.url + '/api/qr/' + encodeURIComponent(link)
      ).then((res) => res.json());
      setQrDataUrl(response);
    };

    fetchQrDataUrl();
  }, [gameId]);

  return (
    <div
      className={classNames(
        `rounded-xl p-6`,
        qrDataUrl ? 'bg-white' : 'bg-malibu'
      )}
    >
      {qrDataUrl ? (
        <img src={qrDataUrl} width={176} height={176} className="rounded-xl" />
      ) : (
        <div className="bg-malibu grid h-44 w-44 place-content-center rounded-xl">
          <LoadingAnimation />
        </div>
      )}
    </div>
  );
};

export default QrCode;
